export const BadgeModel = [
  {
    key: "title",
    dataType: String,
  },
  {
    key: "image",
    dataType: String,
  },
  {
    key: "uid",
    dataType: String,
  },
];
